module.exports = {"220322001":"富强街道","220322002":"康平街道","220322003":"霍家店街道","220322100":"梨树镇","220322101":"郭家店镇","220322102":"榆树台镇","220322103":"孤家子镇","220322104":"小城子镇","220322105":"喇嘛甸镇","220322106":"蔡家镇","220322107":"刘家馆子镇","220322108":"十家堡镇","220322109":"孟家岭镇","220322110":"万发镇","220322111":"东河镇","220322112":"沈洋镇","220322113":"林海镇","220322114":"小宽镇","220322200":"白山乡","220322201":"泉眼岭乡","220322202":"胜利乡","220322203":"四棵树乡","220322204":"双河乡","220322205":"金山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220322.json
// module id = 720
// module chunks = 0